export default function getNonWhiteSpaceCharacterLength(word) {
  if (word) {
    return word.replace(/\s/g, '').length;
  }
  return 0;
}
